module.exports = __webpack_public_path__ + "components/weather-icon/static/dayclear@3-c1f8121b46449b471194241ff6f56fad.png";